import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Guarantee() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-142" data-mp="1o2vjmvsbez9q">
      <div className="mx-auto max-w-2xl" data-id="element-143" data-mp="223oejhmj3wdd">
        <div className="rounded-3xl border-2 border-brand-500/25 bg-white p-6 text-center sm:p-9" data-id="element-144" data-mp="222n156i1ixsh">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-brand-50" data-id="element-145" data-mp="1x54ob50wjyf7">
            <ShieldCheckIcon className="h-7 w-7 text-brand-500" aria-hidden="true" data-id="element-146" data-mp="19co8l14n0ij2" />
          </span>
          <h2 className="mt-5 font-display text-[24px] font-extrabold leading-tight text-ink sm:text-3xl" data-id="element-147" data-mp="14dl3jgonqcb3">
            Garanzia di soddisfazione di 7 giorni
          </h2>
          <p className="mt-4 text-[15px] font-medium leading-relaxed text-inksoft sm:text-base" data-id="element-148" data-mp="1ed28twzzyo6j">
            Puoi esplorare il Kit durante i prossimi 7 giorni. Se ritieni che il materiale non ti
            aiuti a organizzare meglio le tue decisioni cliniche o semplicemente non faccia al caso
            tuo, contattaci e riceverai il 100% del tuo pagamento indietro.
          </p>
          <p className="mt-4 text-[14px] font-bold uppercase tracking-wider text-brand-600" data-id="element-149" data-mp="txkvr892ng27">
            Nessun rischio · Nessuna complicazione
          </p>
        </div>

        <div className="mt-10" data-id="element-150" data-mp="12qoftze82r5t">
          <CtaButton label="Provalo senza rischi" note="Garanzia di 7 giorni · Rimborso del 100%" data-id="element-151" data-mp="12pmsavg0sc77" />
        </div>
      </div>
    </section>;
}